import React from 'react';


export default class Vitoria extends React.Component {
    render() {
            return (
                <div className="dialogo vitoriaDialogo col">
                    <div className='row center container'>
                        <div className='dialogoContentInfo vitoria opacidade bkColor1 Color4'>
                            <div className="dialogoMainVitoria bkColor3 col-md center fullWidth">
                                <div className="col m6 center">
                                    {this.props.col1} 
                                </div>
                                <div className="col m6 center">
                                    {this.props.col2} 
                                </div>
                                <div className="divider">
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            );
    }
}